import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-image-container">
          <img src="/amegnonatg-banner.jpg" alt="Amegnona Club" className="hero-image" />
        </div>
        <div className="hero-content">
          <h1>Welcome to Amegnona Club</h1>
          <p className="hero-subtitle">Tablabla afe wô tsona</p>
          <p className="hero-description">
            Creating a spirit of brotherhood, solidarity, and mutual assistance between members during life's joyful and challenging moments since 1995.
          </p>
          <Link to="/about" className="cta-button">Learn More</Link>
        </div>
      </section>
      
      <section className="features">
        <div className="container">
          <div className="feature-grid">
            <div className="feature-card">
              <h3>Brotherhood</h3>
              <p>Fostering deep bonds of fraternity and solidarity among all members of our community.</p>
            </div>
            <div className="feature-card">
              <h3>Mutual Support</h3>
              <p>Standing together through life's celebrations and challenges with unwavering assistance.</p>
            </div>
            <div className="feature-card">
              <h3>Community Unity</h3>
              <p>Building lasting connections that strengthen our shared heritage and collective future.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;